import {combineReducers} from 'redux';
import loanApplication from './loanApplication';
import uiReducer from './ui/uiReducer';
import calculator from './calculator';

const turboCashReducer = combineReducers({
    calculator,
    loanApplication,
    ui: uiReducer
});

export default turboCashReducer;